var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2626 5.01514C18.1212 5.01514 17.0681 4.63701 16.2224 3.99912C15.2524 3.26787 14.5556 2.19521 14.3095 0.958887C14.2485 0.653418 14.2157 0.338184 14.2126 0.0151367H10.952V8.92451L10.9481 13.8046C10.9481 15.1093 10.0985 16.2155 8.92079 16.6046C8.579 16.7175 8.20986 16.771 7.82548 16.7499C7.33486 16.7229 6.87509 16.5749 6.47548 16.3358C5.62509 15.8272 5.04853 14.9046 5.0329 13.8491C5.00829 12.1995 6.34189 10.8546 7.99032 10.8546C8.31572 10.8546 8.62822 10.9077 8.92079 11.0042V8.56904V7.69365C8.6122 7.64795 8.29814 7.62412 7.98056 7.62412C6.17626 7.62412 4.48876 8.37412 3.28251 9.72529C2.37079 10.7464 1.82392 12.0491 1.73954 13.4151C1.629 15.2097 2.28564 16.9155 3.55907 18.1741C3.74618 18.3589 3.94267 18.5304 4.14814 18.6886C5.23993 19.5288 6.5747 19.9843 7.98056 19.9843C8.29814 19.9843 8.6122 19.9608 8.92079 19.9151C10.2341 19.7206 11.4458 19.1194 12.402 18.1741C13.577 17.0128 14.2263 15.471 14.2333 13.83L14.2165 6.54248C14.777 6.9749 15.3899 7.33271 16.0477 7.61045C17.0708 8.04209 18.1556 8.26084 19.272 8.26045V5.89287V5.01436C19.2727 5.01514 19.2634 5.01514 19.2626 5.01514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokWhite);
export default __webpack_public_path__ + "static/media/tiktok-white.54513305f1be2bcfe0e2791c13469ad1.svg";
export { ForwardRef as ReactComponent };